module.exports = __webpack_public_path__ + "static/media/pm2.5_v2.693c4662.svg";


//////////////////
// WEBPACK FOOTER
// ./src/weather/svg/pm2.5_v2.svg
// module id = 511
// module chunks = 0